const isEmpty = (obj) => {
    if (obj === undefined) {
        return true;
    }
    if (obj == null) {
        return true;
    }
    return Object.keys(obj).length === 0;
};

function formatStringAsDecimal(str, fallback = '') {
    let number = Number(str);

    if (isNaN(number)) {
        return fallback;
    }

    return number.toFixed(2);
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function formatNumber(value) {
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
}

function camelToSnake(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
}

function snakeToCamel(str) {
    return str.replace(/(_\w)/g, (matches) => matches[1].toUpperCase());
}

function convertObjectKeysToSnakeCase(obj) {
    const result = {};
    for (let key in obj) {
        result[camelToSnake(key)] = obj[key];
    }
    return result;
}

function convertObjectKeysToCamelCase(obj) {
    const result = {};
    for (let key in obj) {
        result[snakeToCamel(key)] = obj[key];
    }
    return result;
}

const copyToClipboard = async (text) => {
    try {
        if (text) {
            await navigator.clipboard.writeText(text);
        }
    } catch (error) {
        console.log('error', error);
    }
};

const filterMenuItems = (menuItems, removeKeys) => {
    if (!removeKeys || removeKeys.length === 0) {
      return menuItems;
    }
  
    const removeChildren = (children) => {
      const filtered = children.filter((child) => !removeKeys.includes(child.key));
      return filtered;
    };
  
    return menuItems
      .map((item) => {        
        if (removeKeys.includes(item.key)) {
          return null;
        }
  
        if (item.children?.length > 0) {
          const filteredChildren = removeChildren(item.children);
          if (filteredChildren.length === 0) {
            return null;
          }
          return { ...item, children: filteredChildren };
        }
  
        return item;
      })
      .filter(Boolean);
  };

function getCurrentSearchParam(searchParams, arrayFields) {
    if (searchParams.size === 0) {
        return {};
    }

    let data = {};

    for (const [key, value] of searchParams.entries()) {
        if (data[key]) {
            if (Array.isArray(data[key])) {
                data[key] = [...data[key], value];
            } else {
                data[key] = [data[key], value];
            }
        } else {
            if (arrayFields.includes(key)) {
                data[key] = [value];
            } else {
                data[key] = value;
            }
        }
    }

    return data;
}

function getFilterCount(filters = {}, DICT) {
    if (Object.keys(filters).length === 0) {
        return 0;
    }

    let filtersArray = [];

    Object.keys(filters).forEach((key) => {
        filtersArray.push(DICT[key]);
    });

    return new Set(filtersArray).size;
}

function getOptionByValue(value, array) {
    for (let group of array) {
        if (!group.options) {
            if (group.value === value) {
                return group;
            }
            continue;
        }
        for (let option of group.options) {
            if (option.value === value) {
                return option;
            }
        }
    }
    return null;
}

export {
    getCurrentSearchParam,
    getFilterCount,
    filterMenuItems,
    isEmpty,
    camelToSnake,
    snakeToCamel,
    formatStringAsDecimal,
    capitalizeFirstLetter,
    formatNumber,
    copyToClipboard,
    convertObjectKeysToSnakeCase,
    convertObjectKeysToCamelCase,
    getOptionByValue,
};
